import { useQuery } from '@tanstack/react-query';
import { api } from '../utils/api';

export interface LandingConfig {
  hero: {
    badge: string;
    title: string;
    subtitle: string;
    description: string;
    bg_image: string;
  };
  about: {
    title: string;
    body_1: string;
    body_2: string;
    bg_image: string;
  };
  features: Array<{ icon: string; text: string }>;
  contact: {
    phone: string;
    address: string;
    instagram: string;
    facebook: string;
    whatsapp: string;
    hours_weekdays?: string;
    hours_weekends?: string;
    map_iframe?: string;
  };
}

export function useLandingConfig() {
  return useQuery<{ success: boolean; data: { id: number; name: string; config: LandingConfig; is_active: boolean } | null }>({
    queryKey: ['landing_active'],
    queryFn: async () => {
      const res = await api.get('/landing/active');
      return res.data;
    }
  });
}
